module.exports = __webpack_public_path__ + "static/simonGame-513218239222310c2d5f2f9b4c3b66cb.png";